import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { CompactCard } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import OvertimeCompensationDatatable from '../Profile/OvertimeCompensation/OvertimeCompensationDatatable';
import columns from '../Shared/OvertimeCompensation/Columns';
import { HROvertimeCompensationsRequest } from '../../requests/dashboards';

const OvertimeCompensationIndex = ({
  moreData,
  setMoreData,
  currentEmployee,
  todayMoment = null,
  twoMonthsAgo = null
}) => {
  const [activeCard, setActiveCard] = useState('all');
  const [cards, setCards] = useState({});
  const [customParams, setCustomParams] = useState({});
  const [nameRangePicker, setNameRangePicker] = useState('date_range');
  const [defaultStartDate, setDefaultStartDate] = useState(twoMonthsAgo);
  const [defaultEndDate, setDefaultEndDate] = useState(todayMoment);

  const dispatch = useDispatch();

  const fetchDashboardCards = useCallback(() => {
    HROvertimeCompensationsRequest({
      dispatch,
      successCallback: response => setCards(camelCaseEmptyStringRecursive(response.data))
    });
  }, [dispatch]);

  const handleClick = card => {
    switch (card) {
      case 'all':
        setCustomParams({});
        setNameRangePicker('date_range');
        setActiveCard('all');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      case 'pending':
        setCustomParams({ status: 'pending' });
        setNameRangePicker('date_range');
        setActiveCard('pending');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      case 'rejected':
        setCustomParams({ status: 'rejected' });
        setNameRangePicker('date_range');
        setActiveCard('rejected');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      default:
        setCustomParams({});
        setNameRangePicker('date_range');
        setActiveCard('all');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(setDefaultStartDate);
        setMoreData(!moreData);
        break;
    }
  };

  useEffect(() => {
    fetchDashboardCards();
  }, [moreData, fetchDashboardCards]);

  return (
    <>
      <Row className="mt-3 mb-3">
        <Col md={3} xs={12}>
          <CompactCard
            variant="info-grey"
            title={cards.all || 0}
            label="Solicitados"
            subtitle="Días Solicitadas"
            active={activeCard === 'all'}
            onClick={() => handleClick('all')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="warning"
            title={cards.pending || 0}
            label="Por Autorizar"
            subtitle="Días por Autorizar"
            active={activeCard === 'pending'}
            onClick={() => handleClick('pending')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="danger"
            title={cards.rejected || 0}
            label="Rechazados"
            subtitle="Días Rechazados"
            active={activeCard === 'rejected'}
            onClick={() => handleClick('rejected')}
          />
        </Col>
      </Row>
      <OvertimeCompensationDatatable
        columns={columns}
        customParams={customParams}
        nameRangePicker={nameRangePicker}
        defaultStartDate={defaultStartDate}
        defaultEndDate={defaultEndDate}
        moreData={moreData}
        setMoreData={setMoreData}
        currentEmployee={currentEmployee}
        rrhh
      />
    </>
  );
};

export default OvertimeCompensationIndex;
